import React from 'react'

const IconVolume = ({size, className, color}) => {
    return (
        <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M14 5.29001V3.23001C18.01 4.14001 21 7.72001 21 12C21 16.28 18.01 19.86 14 20.77V18.71C16.89 17.85 19 15.17 19 12C19 8.83001 16.89 6.15001 14 5.29001ZM3 15V9.00001H7L12 4.00002V20L7 15H3ZM9.99999 15.17V8.83001L7.83 11H5V13H7.83L9.99999 15.17ZM16.5 12C16.5 10.23 15.48 8.71002 14 7.97002V16.02C15.48 15.29 16.5 13.77 16.5 12Z" fill={color ? color : "#48A7FF"} />
        </svg>

    )
}

export default IconVolume
